import type { RouterConfig } from "@nuxt/schema";

// https://router.vuejs.org/api/interfaces/routeroptions.html
export default <RouterConfig>{
  scrollBehavior(to, from, savedPosition) {
    // If the user navigates back/forward, use saved position
    if (savedPosition) {
      return savedPosition;
    }

    // If the route has a hash (anchor), scroll to that element
    // If the route has a hash (anchor), scroll to that element with offset
    if (to.hash) {
      const el = document.querySelector(to.hash);
      if (el) {
        return {
          top: el.getBoundingClientRect().top + window.scrollY - 110, // Fixed offset
          behavior: "smooth",
        };
      }
      return { el: to.hash, behavior: "smooth" };
    }

    // Default: scroll to top of page
    return { top: 0, left: 0, behavior: "instant" };
  },
};
